import { Runtime } from './runtime.js';
import { bridge } from '@dinahmoe/dmafjs-core';

const browserRuntime = new Runtime("browser");

bridge.register(browserRuntime);

export { browserRuntime };
